import {
  Box,
  BoxProps,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Text,
  TextProps,
} from "@chakra-ui/react";
import { FaChevronRight } from "react-icons/fa";

interface PathItems {
  label: string;
  link: string;
  isCurrentPage: boolean;
}

export interface BreadCrumbsSectionProps {
  breadCrumbsContainerProps?: BoxProps;
  breadCrumbsBoxProps?: BoxProps;
  basePath?: PathItems;
  firstPath?: PathItems;
  secondPath?: PathItems;
  thirdPath?: PathItems;
  basePathTextProps?: TextProps;
  firstPathTextProps?: TextProps;
  secondPathTextProps?: TextProps;
  thirdPathTextProps?: TextProps;
}

const BreadCrumbsSection = ({
  breadCrumbsContainerProps,
  breadCrumbsBoxProps,
  basePath = {
    label: "Home",
    link: "/",
    isCurrentPage: false,
  },
  firstPath,
  secondPath,
  thirdPath,
  basePathTextProps,
  firstPathTextProps,
  secondPathTextProps,
  thirdPathTextProps,
}: BreadCrumbsSectionProps) => {
  return (
    <Box {...breadCrumbsContainerProps}>
      <Box {...breadCrumbsBoxProps}>
        <Breadcrumb separator={<FaChevronRight color="gray.500" />}>
          {basePath && (
            <BreadcrumbItem isCurrentPage={basePath.isCurrentPage}>
              <BreadcrumbLink href={basePath.link}>
                <Text {...basePathTextProps}>{basePath.label}</Text>
              </BreadcrumbLink>
            </BreadcrumbItem>
          )}

          {firstPath && (
            <BreadcrumbItem isCurrentPage={firstPath.isCurrentPage}>
              <BreadcrumbLink href={firstPath.link}>
                <Text {...firstPathTextProps}>{firstPath.label}</Text>
              </BreadcrumbLink>
            </BreadcrumbItem>
          )}

          {secondPath && (
            <BreadcrumbItem isCurrentPage={secondPath.isCurrentPage}>
              <BreadcrumbLink href={secondPath.link}>
                <Text {...secondPathTextProps}>{secondPath.label}</Text>
              </BreadcrumbLink>
            </BreadcrumbItem>
          )}

          {thirdPath && (
            <BreadcrumbItem isCurrentPage={thirdPath.isCurrentPage}>
              <BreadcrumbLink href={thirdPath.link}>
                <Text {...thirdPathTextProps}>{thirdPath.label}</Text>
              </BreadcrumbLink>
            </BreadcrumbItem>
          )}
        </Breadcrumb>
      </Box>
    </Box>
  );
};

export default BreadCrumbsSection;
